import { SubsystemId, SubsystemGroup } from '../../services/ai-admin-api';

export interface SubsystemNavEntry {
    id: SubsystemId;
    displayName: string;
    subtitle: string;
    group: SubsystemGroup;
    dependencies: SubsystemId[];
    /** True if this subsystem has placeholder content in Phase 2 (still true for all 11 until Phase 3 cutovers). */
    placeholder: true;
}

/**
 * Static catalog used to render the sidebar / diagram before the API responds.
 * Mirrors the backend SubsystemRegistry (src/ai-admin/registry/) — keep in sync
 * during Phase 3 cutovers.
 */
export const AI_HUB_SUBSYSTEMS: SubsystemNavEntry[] = [
    {
        id: 'shared_prompt_library',
        displayName: 'Shared Prompt Library',
        subtitle: 'Reusable {PLACEHOLDER} fragments.',
        group: 'shared_prompt_library',
        dependencies: [],
        placeholder: true,
    },
    {
        id: 'model_beliefs_ai',
        displayName: 'Model Beliefs',
        subtitle: 'What ChatGPT, Claude and Gemini believe about a brand.',
        group: 'brand_insight',
        dependencies: ['shared_prompt_library', 'models_providers'],
        placeholder: true,
    },
    {
        id: 'models_providers',
        displayName: 'Models & Providers',
        subtitle: 'Anthropic / OpenAI / embedding models with pricing.',
        group: 'infrastructure',
        dependencies: [],
        placeholder: true,
    },
    {
        id: 'knowledge_base',
        displayName: 'Knowledge Base (RAG)',
        subtitle: 'Document store, chunking, embeddings, retrieval knobs.',
        group: 'infrastructure',
        dependencies: [],
        placeholder: true,
    },
    {
        id: 'ai_experts',
        displayName: 'AI Experts',
        subtitle: 'Conversational experts and per-expert dashboard extracts.',
        group: 'conversational',
        dependencies: [],
        placeholder: true,
    },
    {
        id: 'element_analysis',
        displayName: 'Element Analysis',
        subtitle: 'Measured and latent element analysis.',
        group: 'brand_insight',
        dependencies: [],
        placeholder: true,
    },
    {
        id: 'advice_ai',
        displayName: 'Advice AI',
        subtitle: 'Five-section structured brand advice.',
        group: 'brand_insight',
        dependencies: [],
        placeholder: true,
    },
    {
        id: 'orbital_ai',
        displayName: 'Orbital AI',
        subtitle: 'Synthesises Advice AI output into the orbital narrative.',
        group: 'brand_insight',
        dependencies: ['advice_ai'],
        placeholder: true,
    },
    {
        id: 'building_blocks_ai',
        displayName: 'Building Blocks AI',
        subtitle: 'Per-element building-block summaries.',
        group: 'brand_insight',
        dependencies: [],
        placeholder: true,
    },
    {
        id: 'briefing_ai',
        displayName: 'The Briefing AI',
        subtitle: 'Marketer Briefing narrative (One thing · The fix) from Brand Equity data.',
        group: 'brand_insight',
        dependencies: [],
        placeholder: true,
    },
    {
        id: 'hypothesis_ai',
        displayName: 'The Hypothesis AI',
        subtitle: 'Day-0 brand research (website + reviews) and the inferred-constraint Hypothesis.',
        group: 'brand_insight',
        dependencies: [],
        placeholder: true,
    },
    {
        id: 'auto_concierge_ai',
        displayName: 'Auto-Concierge AI',
        subtitle:
            'The generated concierge pack: brand-voice customer email copy, the incentive recommendation and the covering note.',
        group: 'operational',
        dependencies: [],
        placeholder: true,
    },
    {
        id: 'response_monitoring_ai',
        displayName: 'Response Monitoring AI',
        subtitle: 'Scheduled response review with thresholds and AI flagging.',
        group: 'operational',
        dependencies: [],
        placeholder: true,
    },
    {
        id: 'editor_ai',
        displayName: 'Editor AI',
        subtitle: 'Astro static-site editor (SUPER_ADMIN only).',
        group: 'operational',
        dependencies: [],
        placeholder: true,
    },
    {
        id: 'token_quotas',
        displayName: 'Token Quotas & Cost Control',
        subtitle: 'Per-tier token quotas, alerts, sandbox spend threshold.',
        group: 'operational',
        dependencies: [],
        placeholder: true,
    },
];

export const SUBSYSTEM_GROUP_LABELS: Record<SubsystemGroup, string> = {
    shared_prompt_library: 'Shared',
    infrastructure: 'Infrastructure',
    brand_insight: 'Brand Insight',
    conversational: 'Conversational',
    operational: 'Operational',
};

export const SUBSYSTEM_GROUP_ORDER: SubsystemGroup[] = [
    'shared_prompt_library',
    'infrastructure',
    'brand_insight',
    'conversational',
    'operational',
];
